module.exports = __webpack_public_path__ + "img/照片墙.jpg";